import ApprovedCollection from './ApprovedCollection';

export default ApprovedCollection;
